
import {
   clsx
  ,styled
  ,Box
  ,Radio
  ,RadioGroup
  ,FormControlLabel
  ,FormGroup
  ,Checkbox
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

const MultipleChoiceContainer = styled(Box)(multipleChoiceStyles)

export default function MultipleChoice ({question}) {

  const {translate} = useTranslations()
  const {assessment} = useAssessment()

  const answer = assessment.answers[question.id] || {}

  const {properties} = question

  const choices = !properties.shuffle && question.answer.choices || answer.choices || []

  const {selected = null, selectedOptions = []} = answer

  const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice

  return (
    <MultipleChoiceContainer className="root">
      {choices.length > 0 && (
        <Choices
          question={question}
          choices={choices}
          selected={selected}
          selectedOptions={selectedOptions}
        />)}
    </MultipleChoiceContainer>
  )
}

function RadioChoice ({question, choices, selected}) {

  const {save} = useAssessment()
  const handleChange = e => save({[question.id]: { selected: {$set: e.target.value}, completed: {$set: true}}})

  return (
    <RadioGroup className={clsx("choices", "radio")} value={selected} onChange={handleChange}>
      {choices.map((choice, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <Box key={index} className="option">
            <FormControlLabel
              value={choice.id}
              className="choice"
              control={<Radio color="primary" />}
              label={(
                <Box className="optionLabel">
                  <Box className="index">{answerIndex})</Box>
                  <div className="choice-caption" dangerouslySetInnerHTML={{__html: choice.html || ''}} />
                </Box>
              )}
            />
          </Box>)
      })}
    </RadioGroup>
  )
}

function CheckboxChoice ({question, choices, selectedOptions}) {

  const {save} = useAssessment()

  const handleChange = (id, checked) => {
    const value = checked
      ? [...selectedOptions, id]
      : selectedOptions.filter(o => o != id)
    const completed = value.length > 0
    save({[question.id]: {selectedOptions: {$set: value}, completed: {$set: completed} }})
  }

  return (
    <FormGroup className={clsx("choices", "checkbox")}>
      {choices.map((option, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
        <Box key={index} className="option">
          <Box className="checkbox">
            <FormControlLabel
              control={<Checkbox color="primary" checked={selectedOptions.indexOf(option.id) >= 0} onChange={e => handleChange(option.id, e.target.checked)} />}
              label={(
                <Box className="optionLabel">
                  <Box className="index">{answerIndex})</Box>
                  <div className="choice-caption" dangerouslySetInnerHTML={{__html: option.html || ''}} />
                </Box>
              )}
            />
          </Box>
        </Box>
      )})}
    </FormGroup>
  )
}

function multipleChoiceStyles (theme) {
  return {
    "&.root": {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      fontSize: '12pt',
    },
    "& .option": {
      display: 'flex'
    },
    "& .optionLabel": {
      display: 'flex',
      "& > .index": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginRight: 15
      }
    }
  }
}
